<template>
  <v-card class="fluid-column ma-5">

    <div>

      <v-card-item>
        <v-card-title class="text-headline-small">Raccolta</v-card-title>
      </v-card-item>

      <v-card-item>
        <v-card-title class="text-title-large text-grey-darken-2 pl-3">Segnalazioni</v-card-title>
      </v-card-item>

      <v-card-text class="pl-10">
        <p>Da inviare:
        </p>
        <ul style="padding-left: 2em">
          <li>Segnalazioni: {{ dataStore.featuresToBeTransferred.segnalazioni.length }}</li>
          <!-- <li>Tracce: {{ dataStore.featuresToBeTransferred.tracce.length }}</li>
          -->
          <li>Media: {{ transferStore.files_to_upload.length }}</li>
        </ul>
      </v-card-text>

      <v-card-item>
        <v-card-title class="text-title-large text-grey-darken-2 pl-3">Diario</v-card-title>
      </v-card-item>

      <v-card-text class="pl-10">
        <p>Da inviare:
        </p>
        <ul style="padding-left: 2em">
          <li>Giornate: {{ Object.entries(dataStore.journalDaysToBeTransferred).length }}</li>
        </ul>
      </v-card-text>

      <v-card-item>
        <v-card-title class="text-headline-small">Stato</v-card-title>
      </v-card-item>



      <v-card-text class="px-10">
        <div>
          <template v-if="!dataStore.needToTransfer">
            <p class="d-flex flex-row align-center">
              <!-- <v-btn class="no-mouse" size="x-small" icon="mdi-check" color="green-darken-2"
            variant="flat"></v-btn> -->
              <v-icon size="large" icon="mdi-check" color="green-darken-2"></v-icon>
              <span class="ml-2 text-title-large text-grey-darken-2">ok</span>
            </p>
          </template>
          <template v-else>

            <p class="d-flex flex-row align-center" v-if="transferStore.activeDuration > 999">
              <!-- <v-btn class="no-mouse" size="x-small" icon color="orange-darken-3" variant="flat">
          <v-icon :class="transferStore.active ? 'pulsating' : ''">mdi-transfer-up</v-icon>
        </v-btn> -->
              <v-icon size="large" icon color="orange-darken-3"
                  :class="transferStore.active ? 'pulsating' : ''">mdi-transfer-up</v-icon>
              <span class="ml-2 text-title-large text-grey-darken-2">attivo</span><br>
            </p>

            <p class="d-flex flex-row align-center" v-else>
              <!-- <v-btn class="no-mouse" size="x-small" icon="mdi-check" color="grey-darken-2"
            variant="flat"></v-btn> -->
              <v-icon size="large" icon="mdi-check" color="grey-darken-2"></v-icon>

              <span class="ml-2 text-title-large text-grey-darken-2">in attesa</span><br>
              <span class="ml-2">{{ transferStore.waitingReasons }}</span><br>
            </p>
            <!-- <p class="d-flex flex-row align-center" v-else>
      <v-btn class="no-mouse" size="x-small" icon color="grey-darken-3">
        <v-icon>mdi-help</v-icon>
      </v-btn>
      <span class="ml-2 text-title-large text-grey-darken-2">-</span>
    </p> -->
          </template>



        </div>

      </v-card-text>

      <v-card-item>
        <v-card-title class="text-title-large text-grey-darken-2 pl-3">Ultimo controllo</v-card-title>
      </v-card-item>

      <v-card-text class="px-10">

        <p>
          <v-icon size="large" icon="mdi-clock-outline" color="grey" class="mb-1"></v-icon>
          <span class="ml-2 text-title-large text-grey-darken-2">
            {{ transferStore?.lastTry?.date?.toLocaleTimeString() }}
          </span>
        </p>

        <p>
          <v-icon size="large" icon="mdi-note-text-outline" color="grey" class="mb-1"></v-icon>
          <span class="ml-2 text-title-large text-grey-darken-2">
            {{ transferStore.lastTry?.reason }}
          </span>
        </p>


      </v-card-text>

      <v-card-item>
        <v-card-title class="text-title-large text-grey-darken-2 pl-3">Log {{
          transferStore?.lastSuccessfulRun?.date?.toLocaleTimeString() }}</v-card-title>
      </v-card-item>
      <v-card-text class="px-10">
        <!-- <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-title>
              <v-icon class="mr-2" color="grey">mdi-clipboard-text</v-icon>
              mostra / nascondi
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <template v-for="r of transferStore?.lastSuccessfulRun?.log">
                <p class="pt-2">{{ r }}</p>
              </template>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels> -->

        <p class="mt-2">
          <v-btn color="primary" to="/data/transferlog/" size="small">
            <template v-slot:prepend>
              <v-icon>mdi-note-text</v-icon>
            </template>
            Consulta
          </v-btn>
        </p>

      </v-card-text>

      <v-card-item>
        <v-card-title class="text-title-large text-grey-darken-2 pl-3">Storico</v-card-title>
      </v-card-item>

      <v-card-text class="pl-10">
        <p class="mt-0">
          <v-btn color="primary" to="/data/history/" size="small">
            <template v-slot:prepend>
              <v-icon>mdi-history</v-icon>
            </template>
            Consulta
          </v-btn>
        </p>
      </v-card-text>
    </div>
    <div>

      <v-card-item>
        <v-card-title class="text-headline-small">Connessione</v-card-title>
      </v-card-item>
      <v-card-text class="pl-10">

        <p v-if="networkStore.online">

          <!-- <v-btn class="no-mouse" size="x-small" icon color="green-darken-3" variant="flat">
            <v-icon color="white">mdi-check</v-icon>
          </v-btn> -->

          <v-icon size="large" icon="mdi-check" color="green-darken-2"></v-icon>
          <span class="ml-3 text-title-large text-grey-darken-2">
            {{ networkStore.effectiveType }}
          </span>

          <!-- <template v-if="ENVIRONMENT !== 'production'"> -->
          <template>
            <br>
            <template v-if="networkStore?.plainType">
              {{ networkStore?.plainType }}
            </template>
            <template v-else>
              <v-icon size="large" icon="mdi-help" color="grey"></v-icon>
            </template> <span class="ml-3 text-title-large text-grey-darken-2">
              plainType </span>
          </template>
        </p>
        <p v-else>

          <!-- <v-btn class="no-mouse" size="x-small" icon color="red-darken-3" variant="flat">
            <v-icon color="white">mdi-alert</v-icon>
          </v-btn> -->
          <v-icon size="large" icon="mdi-alert" color="red-darken-3"></v-icon>
          <span class="ml-2 text-title-large text-grey-darken-2">
            assente
          </span>
        </p>

      </v-card-text>
    </div>
    <div>

      <v-card-item>
        <v-card-title class="text-headline-small">Server</v-card-title>
      </v-card-item>
      <v-card-text class="pl-10">

        <p v-if="networkStore.trackerServerStatus">
          <!-- <v-btn class="no-mouse" size="x-small" icon color="green-darken-3" variant="flat">
            <v-icon color="white">mdi-check</v-icon>
          </v-btn> -->
          <v-icon size="large" icon="mdi-check" color="green-darken-2" class="mb-1"></v-icon>

          <span class="ml-3 text-title-large text-grey-darken-2">
            online
          </span>
        </p>
        <p v-else>

          <!-- <v-btn class="no-mouse" size="x-small" icon color="yellow-darken-4" variant="flat">
            <v-icon color="white">mdi-alert</v-icon>
          </v-btn> -->
          <v-icon size="large" icon="mdi-alert" color="yellow-darken-4" class="mb-1"></v-icon>

          <span class="ml-2 text-title-large text-grey-darken-2">
            non raggiungibile
          </span>
        </p>

      </v-card-text>




    </div>


  </v-card>
</template>

<script setup>


import { onMounted, computed } from "vue";

// import { inject } from 'vue'


import { useDataStore } from "@/store/data";
const dataStore = useDataStore();


import { useNetworkStore } from "@/store/network";
const networkStore = useNetworkStore();

import { useTransferStore } from "@/store/transfer"
const transferStore = useTransferStore()

import { useHistoryStore } from "@/store/history"
const historyStore = useHistoryStore()

// const connection = computed(() => {
//   return navigator.connection.effectiveType
// })




onMounted(() => {



});


</script>

<style scoped>
.pulsating {
  animation-name: color;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate-reverse;
  animation-timing-function: linear;
}


@keyframes color {
  from {
    color: orange;
  }

  to {
    color: white;
    text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px orange;
  }
}

.no-mouse {
  pointer-events: none;
}
</style>
